<template>
  <div class="row product-content-infowrap" v-if="hasData()">
    <div class="col-sm-6 product-content-infoimagewrap" v-if="false && product.sharedFile && product.sharedFile[imageIndex] && !hideImage" :title="(product.sharedFile[imageIndex].title ? product.sharedFile[imageIndex].title : '') + (product.sharedFile[imageIndex].title && product.sharedFile[imageIndex].description ?  ' - ' : '') + (product.sharedFile[imageIndex].description ? product.sharedFile[imageIndex].description : '')">
       <a :id="'gallery-' + shopId + '-' + product.sharedFile[imageIndex].id" :href="(product.sharedFile[imageIndex].video ? 'https://www.youtube.com/embed/' + $filters.youtubeId(product.sharedFile[imageIndex].video) + '?autoplay=1' : baseDomain + shopId + '/files/' + product.sharedFile[imageIndex].id + '.' + encodeURI((product.sharedFile[imageIndex].filename.split('.').pop() ? product.sharedFile[imageIndex].filename.split('.').pop() : 'jpg')))" :class="'product-content-infoimage lazy match-row ' + (product.sharedFile[imageIndex].video ? 'video-link' : 'image-link')" v-lazy:background-image="baseDomain + shopId + '/files/' + product.sharedFile[imageIndex].id + '.' + encodeURI((product.sharedFile[imageIndex].filename.split('.').pop() ? product.sharedFile[imageIndex].filename.split('.').pop() : 'jpg'))"><img class="js-product-printinfoimage product-content-printinfoimage visible-print-block" :src="baseDomain + shopId + '/files/' + product.sharedFile[imageIndex].id + '.' + encodeURI((product.sharedFile[imageIndex].filename.split('.').pop() ? product.sharedFile[imageIndex].filename.split('.').pop() : 'jpg'))" :alt="(product.sharedFile[imageIndex].title ? product.sharedFile[imageIndex].title : '') + (product.sharedFile[imageIndex].title && product.sharedFile[imageIndex].description ?  ' - ' : '') + (product.sharedFile[imageIndex].description ? product.sharedFile[imageIndex].description : '')"/></a>
    </div>
    <div class="col-xs-12 col-p-6 product-content-infotext match-row">
      <div class="product-content-infoblock">
        <h3 class="product-content-infotitle" v-if="title">{{ title }}</h3>
        <div class="product-content-infotable">
          <div class="product-content-inforow" v-for="field in fields" v-if="fieldHasData(field)">
            <div class="product-content-infolabel" v-if="getFieldTitle(field)" v-html="sanitizeHtml(getFieldTitle(field))"></div>
            <div class="product-content-infovalue text-content" v-html="sanitizeHtml(getFieldData(field))"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import nl2br from 'nl2br'
import sanitizeHtml from '~/lib/sanitizehtml'

export default {
  data () {
    return {
      SUBTYPE_EVENT: 4,
      lightbox: null,
      imageIndex: this.$store.state.imageIndex
    }
  },
  props: ['product', 'title', 'fields', 'baseDomain', 'shopId', 'hideImage'],
  methods: {
    sanitizeHtml,
    hasData () {
      for (var i = 0; i < this.fields.length; i++) {
        let d = this.getFieldData(this.fields[i])
        if (d && d !== '0' && d !== 0) {
          return true
        }
      }
      return false
    },
    fieldHasData (field) {
      let d = this.getFieldData(field)
      if (d && d !== '0' && d !== 0) {
        return true
      }
      return false
    },
    getFieldTitle (field) {
      let _ = this._
      let titles = {
        'description': '',
        'location': _('Location'),
        'apartmenttype': _('Holiday apartment type'),
        'livingarea': _('Living area'),
        'numberofbeds': _('Number of beds'),
        'extrabeds': _('Extra beds'),
        'constructionyear': _('Construction year'),
        'renovationyear': _('Renovation year'),
        'furtherinformation': _('Further information'),
        'facilities': _('Facilities'),
        'featuredescription': _('Feature description'),
        'entertainmentproperties': _('Entertainment'),
        'kitchenproperties': _('Kitchen equipment'),
        'numberofkitchensets': _('Number of kitchen sets'),
        'kitcheninformation': _('Kitchen description'),
        'yardproperties': _('Garden equipment'),
        'yarddescription': _('Yard description'),
        'shoretype': _('Shore'),
        'shoredescription': _('Shore description'),
        'carproperties': _('Parking'),
        'accessibilityproperties': _('Accessibility'),
        'categories': _('Classification'),
        'activityproperties': _('Activities'),
        'activitiesdescription': _('Activities description'),
        'restrictions': _('Restrictions'),
        'serviceinformation': _('Services'),
        'trafficconnections': _('Traffic connections'),
        'drivinginstructions': _('Driving instructions'),
        'languages': _('Languages'),
        'difficulty': _('Difficulty'),
        'suitability': _('Suitable for'),
        'insurances': _('Insurance plans'),
        'qualifications': _('Qualifications'),
        'website': _('Website'),
        'originaltitle': _('Original title'),
        'duration': _('Duration'),
        'director': _('Director'),
        'actors': _('Actors'),
        'script': _('Script'),
        'creditsmisc': _('Miscellaneous credits'),
        'materialnotes': _('Material notes')
      }
      return titles[field] !== false ? titles[field] : field
    },
    getFieldData (field) {
      if (!this.product.channeldata) {
        return ''
      }
      switch (field) {
        case 'location':
          return this.getLocation()
        case 'facilities':
          return this.getFacilities().toLowerCase()
        case 'entertainmentproperties':
          return this.getEntertainment().toLowerCase()
        case 'kitchenproperties':
          return this.getKitchen().toLowerCase()
        case 'yardproperties':
          return this.getYard().toLowerCase()
        case 'carproperties':
          return this.getCar().toLowerCase()
        case 'accessibilityproperties':
          return this.getAccessibility().toLowerCase()
        case 'activityproperties':
          return this.getActivities().toLowerCase()
        case 'categories':
          return this.getCategories().toLowerCase()
        case 'restrictions':
          return this.getRestrictions().toLowerCase()
        case 'serviceinformation':
        case 'trafficconnections':
        case 'drivinginstructions':
          return this.product.channeldata[field] ? nl2br(this.product.channeldata[field]) : false
        case 'website':
          return this.getWebsite()
        case 'shoretype':
          return this._(this.product.channeldata[field])
        case 'duration':
          if (parseInt(this.product.subtype, 10) === this.SUBTYPE_EVENT) {
            return this._(this.product.channeldata[field]) + ' ' + this._('min')
          }
          return this._(this.product.channeldata[field])
        case 'apartmenttype':
          return this.getApartmentType(this.product.channeldata[field])
      }
      return this.product.channeldata[field]
    },
    getLocation () {
      let s = ''
      let product = this.product
      if (!product || !product.channeldata) {
        return s
      }
      if (product.channeldata.municipality) {
        s += product.channeldata.municipality + '<br />'
      }
      let addressItems = []
      if (product.channeldata.streetaddress && parseInt(product.channeldata.streetaddress) !== 0) {
        addressItems.push(product.channeldata.streetaddress)
      }
      let postAddress = ''
      if (product.channeldata.postcode && parseInt(product.channeldata.postcode) !== 0) {
        postAddress += product.channeldata.postcode + ' '
      }
      if (product.channeldata.postarea && parseInt(product.channeldata.postarea) !== 0) {
        postAddress += product.channeldata.postarea
      }
      if (postAddress !== '') {
        addressItems.push(postAddress)
      }
      s += addressItems.join(', ')
      return s
    },
    getFacilities () {
      let props = []
      let _ = this._
      if (!this.product || !this.product.channeldata || !this.product.channeldata.attributes) {
        return ''
      }
      for (var attr in this.product.channeldata.attributes) {
        if (Object.prototype.hasOwnProperty.call(this.product.channeldata.attributes, attr)) {
          switch (attr) {
            case 'fireplace':
              props.push(_('Fireplace'))
              break
            case 'washingmachine':
              props.push(_('Washing machine'))
              break
            case 'bathtub':
              props.push(_('Bath tub'))
              break
            case 'hottub':
              props.push(_('Hot tub'))
              break
            case 'shower':
              props.push(_('Shower'))
              break
            case 'indoorsauna':
              props.push(_('Indoor sauna'))
              break
            case 'outdoorsauna':
              props.push(_('Outdoor sauna'))
              break
            case 'saunaonshore':
              props.push(_('Sauna on shore'))
              break
            case 'smokesauna':
              props.push(_('Smoke sauna'))
              break
            case 'steamsauna':
              props.push(_('Steam sauna'))
              break
            case 'publicsauna':
              props.push(_('Public sauna'))
              break
            case 'wc':
              props.push(_('WC'))
              break
            case 'outhouse':
              props.push(_('Outhouse'))
              break
            case 'dryer':
              props.push(_('Dryer'))
              break
            case 'dryercloset':
              props.push(_('Dryer closet'))
              break
            case 'floorheating':
              props.push(_('Floor heating'))
              break
            case 'iron':
              props.push(_('Iron and ironing board'))
              break
          }
        }
      }
      return props.join(', ')
    },
    getEntertainment () {
      let props = []
      let _ = this._
      if (!this.product || !this.product.channeldata || !this.product.channeldata.attributes) {
        return ''
      }
      for (var attr in this.product.channeldata.attributes) {
        if (Object.prototype.hasOwnProperty.call(this.product.channeldata.attributes, attr)) {
          switch (attr) {
            case 'internet':
              props.push(_('Internet connection'))
              break
            case 'tv':
              props.push(_('TV'))
              break
            case 'cable':
              props.push(_('Satellite or cable TV'))
              break
            case 'radio':
              props.push(_('Radio'))
              break
            case 'cd':
              props.push(_('CD player'))
              break
            case 'dvd':
              props.push(_('DVD player'))
              break
            case 'bluray':
              props.push(_('Blu-ray player'))
              break
            case 'computer':
              props.push(_('Computer'))
              break
          }
        }
      }
      return props.join(', ')
    },
    getKitchen () {
      let props = []
      let _ = this._
      if (!this.product || !this.product.channeldata || !this.product.channeldata.attributes) {
        return ''
      }
      for (var attr in this.product.channeldata.attributes) {
        if (Object.prototype.hasOwnProperty.call(this.product.channeldata.attributes, attr)) {
          switch (attr) {
            case 'toaster':
              props.push(_('Toaster'))
              break
            case 'blender':
              props.push(_('Blender'))
              break
            case 'stove':
              props.push(_('Stove'))
              break
            case 'oven':
              props.push(_('Oven'))
              break
            case 'refrigerator':
              props.push(_('Refrigerator'))
              break
            case 'freezer':
              props.push(_('Freezer'))
              break
            case 'cooler':
              props.push(_('Cooler'))
              break
            case 'coffee':
              props.push(_('Coffee machine'))
              break
            case 'waterboiler':
              props.push(_('Electric water boiler'))
              break
            case 'cooking':
              props.push(_('Cooking equipment'))
              break
            case 'microwave':
              props.push(_('Microwave oven'))
              break
            case 'dishwasher':
              props.push(_('Dish washer'))
              break
          }
        }
      }
      return props.join(', ')
    },
    getYard () {
      let props = []
      let _ = this._
      if (!this.product || !this.product.channeldata || !this.product.channeldata.attributes) {
        return ''
      }
      for (var attr in this.product.channeldata.attributes) {
        if (Object.prototype.hasOwnProperty.call(this.product.channeldata.attributes, attr)) {
          switch (attr) {
            case 'barbeque':
              props.push(_('Barbeque'))
              break
            case 'garden':
              props.push(_('Garden'))
              break
            case 'terrace':
              props.push(_('Terrace'))
              break
          }
        }
      }
      return props.join(', ')
    },
    getCar () {
      let props = []
      let _ = this._
      if (!this.product || !this.product.channeldata || !this.product.channeldata.attributes) {
        return ''
      }
      for (var attr in this.product.channeldata.attributes) {
        if (Object.prototype.hasOwnProperty.call(this.product.channeldata.attributes, attr)) {
          switch (attr) {
            case 'carsocketslot':
              props.push(_('Socket slot'))
              break
            case 'parkingsquare':
              props.push(_('Parking square'))
              break
            case 'carshelter':
              props.push(_('Car shelter'))
              break
            case 'garage':
              props.push(_('Garage'))
              break
          }
        }
      }
      return props.join(', ')
    },
    getAccessibility () {
      let props = []
      let _ = this._
      if (!this.product || !this.product.channeldata || !this.product.channeldata.attributes) {
        return ''
      }
      for (var attr in this.product.channeldata.attributes) {
        if (Object.prototype.hasOwnProperty.call(this.product.channeldata.attributes, attr)) {
          switch (attr) {
            case 'carnecessary':
              props.push(_('Car necessary'))
              break
            case 'weelchairaccessible':
              props.push(_('Wheelchair-accessible'))
              break
            case 'suitableforchildren':
              props.push(_('Suitable for children'))
              break
          }
        }
      }
      return props.join(', ')
    },
    getActivities () {
      let props = []
      let _ = this._
      if (!this.product || !this.product.channeldata || !this.product.channeldata.attributes) {
        return ''
      }
      for (var attr in this.product.channeldata.attributes) {
        if (Object.prototype.hasOwnProperty.call(this.product.channeldata.attributes, attr)) {
          switch (attr) {
            case 'fishing':
              props.push(_('Fishing'))
              break
            case 'hiking':
              props.push(_('Hiking'))
              break
            case 'canoeing':
              props.push(_('Canoeing'))
              break
            case 'swimming':
              props.push(_('Swimming'))
              break
            case 'diving':
              props.push(_('Diving'))
              break
            case 'tennis':
              props.push(_('Tennis'))
              break
            case 'golf':
              props.push(_('Golf'))
              break
            case 'biking':
              props.push(_('Biking'))
              break
            case 'hunting':
              props.push(_('Hunting'))
              break
            case 'boating':
              props.push(_('Boating'))
              break
            case 'sightseeing':
              props.push(_('Sightseeing'))
              break
            case 'downhillskiing':
              props.push(_('Downhill skiing'))
              break
            case 'crosscountryskiing':
              props.push(_('Cross-country skiing'))
              break
            case 'horsebackriding':
              props.push(_('Horseback riding'))
              break
            case 'picking':
              props.push(_('Picking mushrooms / berries'))
              break
            case 'iceskating':
              props.push(_('Ice skating'))
              break
            case 'rollerskating':
              props.push(_('Roller skating'))
              break
            case 'waterskiing':
              props.push(_('Water skiing'))
              break
            case 'motorsledging':
              props.push(_('Motor sledging'))
              break
            case 'activitiesforchildren':
              props.push(_('Activities for children'))
              break
            case 'spa':
              props.push(_('Spa'))
              break
          }
        }
      }
      return props.join(', ')
    },
    getCategories () {
      let categories = []
      let _ = this._
      if (!this.product || !this.product.channeldata || !this.product.channeldata.categories) {
        return ''
      }
      for (var attr in this.product.channeldata.categories) {
        if (Object.prototype.hasOwnProperty.call(this.product.channeldata.categories, attr)) {
          switch (attr) {
            case 'activity':
              categories.push(_('Activity'))
              break
            case 'iceswimming':
              categories.push(_('Ice swimming'))
              break
            case 'carting':
              categories.push(_('Carting'))
              break
            case 'movies':
              categories.push(_('Movies'))
              break
            case 'animalpark':
              categories.push(_('Animal park'))
              break
            case 'experience':
              categories.push(_('Experience'))
              break
            case 'geocaching':
              categories.push(_('Geocaching'))
              break
            case 'golf':
              categories.push(_('Golf'))
              break
            case 'crosscountryskiing':
              categories.push(_('Cross-country skiing'))
              break
            case 'slowingdown':
              categories.push(_('Slowing down'))
              break
            case 'amusementpark':
              categories.push(_('Amusement park'))
              break
            case 'wellbeing':
              categories.push(_('Well-being'))
              break
            case 'yoga':
              categories.push(_('Yoga'))
              break
            case 'fishing':
              categories.push(_('Fishing'))
              break
            case 'nationalpark':
              categories.push(_('National park'))
              break
            case 'city':
              categories.push(_('City attraction'))
              break
            case 'rockclimbing':
              categories.push(_('Rock climbing'))
              break
            case 'churches':
              categories.push(_('Churches'))
              break
            case 'rafting':
              categories.push(_('White water rafting'))
              break
            case 'culture':
              categories.push(_('Cultural attraction'))
              break
            case 'gym':
              categories.push(_('Gym'))
              break
            case 'spa':
              categories.push(_('Spa'))
              break
            case 'handicraft':
              categories.push(_('Handicraft'))
              break
            case 'walking':
              categories.push(_('Walking'))
              break
            case 'forchildren':
              categories.push(_('For children'))
              break
            case 'downhillskiing':
              categories.push(_('Downhill skiing'))
              break
            case 'jogging':
              categories.push(_('Jogging'))
              break
            case 'sports':
              categories.push(_('Sports'))
              break
            case 'castle':
              categories.push(_('Castle'))
              break
            case 'skating':
              categories.push(_('Skating'))
              break
            case 'snowshoeing':
              categories.push(_('Snowshoeing'))
              break
            case 'snowboarding':
              categories.push(_('Snowboarding'))
              break
            case 'nature':
              categories.push(_('Natural attraction'))
              break
            case 'naturereserve':
              categories.push(_('Nature reserve'))
              break
            case 'naturecenter':
              categories.push(_('Nature center'))
              break
            case 'monastery':
              categories.push(_('Monastery'))
              break
            case 'mountainbiking':
              categories.push(_('Mountain biking'))
              break
            case 'canoeing':
              categories.push(_('Canoeing'))
              break
            case 'hunting':
              categories.push(_('Hunting'))
              break
            case 'motorsledging':
              categories.push(_('Motor sledging'))
              break
            case 'museum':
              categories.push(_('Museum'))
              break
            case 'atvride':
              categories.push(_('ATV ride'))
              break
            case 'sightseeing':
              categories.push(_('Sightseeing'))
              break
            case 'exhibitions':
              categories.push(_('Exhibitions'))
              break
            case 'shopping':
              categories.push(_('Shopping'))
              break
            case 'localdelicacy':
              categories.push(_('Local delicacy'))
              break
            case 'sleddinghill':
              categories.push(_('Sledding hill'))
              break
            case 'cycling':
              categories.push(_('Cycling'))
              break
            case 'horsebackriding':
              categories.push(_('Horseback riding'))
              break
            case 'restaurant':
              categories.push(_('Restaurant'))
              break
            case 'camping':
              categories.push(_('Camping'))
              break
            case 'tourskating':
              categories.push(_('Tour skating'))
              break
            case 'cruise':
              categories.push(_('Cruise'))
              break
            case 'rollerskating':
              categories.push(_('Roller skating'))
              break
            case 'food':
              categories.push(_('Food'))
              break
            case 'groupexercise':
              categories.push(_('Group exercise'))
              break
            case 'sauna':
              categories.push(_('Sauna'))
              break
            case 'adventure':
              categories.push(_('Adventure'))
              break
            case 'wallclimbing':
              categories.push(_('Wall climbing'))
              break
            case 'berryandmushroompicking':
              categories.push(_('Berry and mushroom picking'))
              break
            case 'diving':
              categories.push(_('Diving'))
              break
            case 'sup':
              categories.push(_('Stand up paddling'))
              break
            case 'orienteering':
              categories.push(_('Orienteering'))
              break
            case 'winteroutdooractivities':
              categories.push(_('Winter outdoor activities'))
              break
            case 'dancing':
              categories.push(_('Dancing'))
              break
            case 'events':
              categories.push(_('Events'))
              break
            case 'tennis':
              categories.push(_('Tennis'))
              break
            case 'swimming':
              categories.push(_('Swimming'))
              break
            case 'hiking':
              categories.push(_('Hiking'))
              break
            case 'hikingtrail':
              categories.push(_('Hiking trail'))
              break
            case 'boating':
              categories.push(_('Boating'))
              break
            case 'waterskiing':
              categories.push(_('Water skiing'))
              break
            case 'animation':
              categories.push(_('animation'))
              break
            case 'anime':
              categories.push(_('anime'))
              break
            case 'documentary':
              categories.push(_('documentary'))
              break
            case 'drama':
              categories.push(_('drama'))
              break
            case 'dubbed':
              categories.push(_('dubbed'))
              break
            case 'fantasy':
              categories.push(_('fantasy'))
              break
            case 'suspense':
              categories.push(_('suspense'))
              break
            case 'horror':
              categories.push(_('horror'))
              break
            case 'family':
              categories.push(_('family'))
              break
            case 'comedy':
              categories.push(_('comedy'))
              break
            case 'domestic':
              categories.push(_('domestic'))
              break
            case 'music':
              categories.push(_('music'))
              break
            case 'musical':
              categories.push(_('musical'))
              break
            case 'original':
              categories.push(_('original'))
              break
            case 'romanticdrama':
              categories.push(_('romantic drama'))
              break
            case 'romanticcomedy':
              categories.push(_('romantic comedy'))
              break
            case 'scifi':
              categories.push(_('scifi'))
              break
            case 'war':
              categories.push(_('war'))
              break
            case 'action':
              categories.push(_('action'))
              break
            case 'western':
              categories.push(_('western'))
              break
          }
        }
      }
      return categories.join(', ')
    },
    getRestrictions () {
      let props = []
      let _ = this._
      if (this.product && this.product.channeldata && this.product.channeldata.attributes) {
        if (this.product.channeldata.attributes.pets) {
          props.push(_('Pets allowed'))
        } else if (this.product.channeldata.attributes.nopets) {
          props.push(_('Pets not allowed'))
        }
        if (this.product.channeldata.attributes.smoking) {
          props.push(_('Smoking allowed'))
        } else if (this.product.channeldata.attributes.nosmoking) {
          props.push(_('Smoking not allowed'))
        }
      }
      if (!props.length) {
        return ''
      }
      return props.join(', ')
    },
    getWebsite () {
      if (!this.product || !this.product.channeldata || !this.product.channeldata.website) {
        return ''
      }
      let url = this.product.channeldata.website
      if (!url.match(/^http/)) {
        url = 'http://' + url
      }
      return '<a href="' + url + '" target="_blank">' + url + '</a>'
    },
    getApartmentType (type) {
      let _ = this._
      switch (type) {
        case 'cottage':
          type = _('Cottage')
          break
        case 'villa':
          type = _('Villa')
          break
        case 'cabin':
          type = _('Cabin')
          break
        case 'chalet':
          type = _('Chalet')
          break
        case 'bnb':
          type = _('Bed and Breakfast')
          break
        case 'castle':
          type = _('Castle')
          break
        case 'farm':
          type = _('Farm')
          break
        case 'farmhouse':
          type = _('Farmhouse')
          break
        case 'house':
          type = _('House')
          break
        case 'apartment':
          type = _('Apartment')
          break
        case 'room':
          type = _('Room')
          break
        case 'granary':
          type = _('Granary')
          break
        case 'lapphut':
          type = _('Lapp hut')
          break
        case 'campingsite':
          type = _('Camping site')
          break
        case 'other':
          type = _('Other')
          break
      }
      return _(type)
    },
    initializeLightbox() {
      try {
        this.lightbox.destroy()
      } catch (e) {
      }
      /*
      if (!jQuery || !jQuery.SimpleLightbox) {
        return
      }
      if(this.product && this.product.sharedFile && this.product.sharedFile[this.imageIndex]) {
        this.lightbox = new jQuery.SimpleLightbox({
          $items: jQuery('#gallery-' + this.shopId + '-' + this.product.sharedFile[this.imageIndex].id),
          captionAttribute: 'data-title',
          videoRegex: new RegExp(/youtube.com|vimeo.com|youtu.be/)
        })
      }
      */
    },
    lightboxTrigger() {
      this.EventBus.$emit('lightboxClick')
    }
  },
  created: async function () {
    if (!this.hideImage) {
      await this.$store.dispatch('setImageIndex', this.$store.state.imageIndex + 1)
    }
  },
  mounted () {
    this.initializeLightbox()
  },
  updated () {
    this.initializeLightbox()
  },
  beforeUnmount () {
    if (this.lightbox !== null) {
      this.lightbox.destroy()
    }
  }
}
</script>
